import { DownOutlined } from '@ant-design/icons';
import { Button, Card, Modal, Select, Tag } from 'antd';
import { useToast } from 'components/Toast';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectListCourses, selectListPeriod } from 'store/common/shared/selectors';
import { CompetitionRatingHttp } from 'store/competionRatingEdu/services/competitionRatingEdu.http';
import styled from 'styled-components';
import _ from 'lodash';
import type { CustomTagProps } from 'rc-select/lib/BaseSelect';
import { RESPONSE_MESSAGE } from 'store/competionRatingEdu/constants/competitionRatingEdu.constants';
import { ListAgenciesSoHttp } from 'store/ListAgenciesSo/services/ListAgenciesSo.http';
import useAuth from 'hooks/useAuth';
import { DonVi, groupUnitPgd, unitPgdQ3 } from '_constants/default.constants';

const Container = styled.div`
  box-shadow: 0 4px 6px -1px rgb(113 126 195 / 10%), 0 2px 4px -2px rgb(113 126 195 / 10%);
  margin-bottom: 10px;
`;
const StyleSelectCourse: typeof Select = styled(Select)`
  height: 40px;
  box-shadow: 0 4px 6px -1px rgb(113 126 195 / 10%), 0 2px 4px -2px rgb(113 126 195 / 10%);
  border-radius: 5px;
  & .ant-select-selector {
    height: 40px !important;
    border-radius: 5px !important;
    & .ant-select-selection-search {
        height: 40px !important;
     }
     & .ant-select-selection-search-input {
        height: 40px !important;
     }
     & .ant-select-selection-item {
        line-height: 40px !important;
     }
     & .ant-select-selection-placeholder {
        line-height: 40px !important;
     }
    }
  }
` as any;

const StyleSelectPeriod: typeof Select = styled(Select)`
  height: 40px;
  box-shadow: 0 4px 6px -1px rgb(113 126 195 / 10%), 0 2px 4px -2px rgb(113 126 195 / 10%);
  border-radius: 5px;
  &:hover > div {
    cursor: pointer !important;
  }
  & .ant-select-selector {
    height: 40px !important;
    border-radius: 5px !important;
    & .ant-select-selection-search {
        height: 40px !important;
     }
     & .ant-select-selection-search-input {
        height: 40px !important;
     }
     & .ant-select-selection-item {
        line-height: 40px !important;
     }
     & .ant-select-selection-placeholder {
        line-height: 40px !important;
     }
    }
    
}
` as any;
const IconDropdown = styled.span`
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  top: 50%;
  right: 11px;
  display: flex;
  align-items: center;
  height: 12px;
  margin-top: -6px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
  line-height: 1;
  text-align: center;
  pointer-events: none;
`;

interface IModalEditRoleEdu {
  isOpen: boolean;
  handleCancel: () => void;
  title?: string;
  id?: string;
  data?: any;
  handleRefresh: () => void;
}

const { Option } = Select;
function ModalEditReviewRoleEdu({
  isOpen,
  title,
  data,
  handleCancel,
  id,
  handleRefresh
}: IModalEditRoleEdu) {
  const toast = useToast();
  const listCourse: any = useSelector(selectListCourses);
  const listPeriod = useSelector(selectListPeriod);

  const [yearSchool, setYearSchool] = useState<string>('');
  const [titleReview, setTitleReview] = useState<string>('');
  const [valueDepartment, setValueDepartment] = useState<any>();
  const [period, setPeriod] = useState<string[]>([]);
  const [valueDonVi, setValueDonVi] = useState<any>();
  const [department, setDepartment] = useState<any>();
  const [isDepartment, setIsDepartment] = useState<boolean>(false);
  const { filters, setFilters } = useAuth();

  const competitionRatingHttp = new CompetitionRatingHttp();
  const listAgenciesSoHttp = new ListAgenciesSoHttp();

  useEffect(() => {
    detailReviewRoleEdu();
    loadListUserDepartments();
    if (data) {
      if (
        data?.evaluation_detail?.evaluation.permissions !== null ||
        data?.evaluation_detail?.evaluation.permissions.length > 0
      ) {
        setIsDepartment(true);
      } else {
        setIsDepartment(false);
      }
    }
  }, [data]);

  const detailReviewRoleEdu = () => {
    competitionRatingHttp.detailReviewRoleEdu(id).then((res) => {
      if (res.ok && res.status === 200) {
        const { data } = res.data;
        setTitleReview(data.evaluation_detail.evaluation.title);
        setValueDepartment(data.evaluation_detail.evaluation.department_id);
        setYearSchool(data.evaluation_detail.evaluation.course_id);
        setValueDonVi(data.evaluation_detail.evaluation.evaluation_code_id);
        setPeriod([...period, ...data.evaluation_detail.evaluation.period_ids]);
      } else {
        // getDetailReview();
      }
    });
  };

  const loadListUserDepartments = () => {
    listAgenciesSoHttp.getListAgenciesSoDepartments(filters).then((res) => {
      if (res.ok && res.status === 200) {
        setDepartment(res.data.data.edu_schools);
      }
    });
  };

  const onSelectYear = (value: string): void => {
    setYearSchool(value);
  };

  const onChangeValue = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setTitleReview((e.target as HTMLInputElement).value);
  };

  const onSelectPeriod = (value: string[]): void => {
    setPeriod(value);
  };

  const onChangeOptionDepartment = (e) => {
    setValueDepartment(e);
  };

  const onChangeOptionDonvi = (e) => {
    setValueDonVi(e);
  };

  const handleSubmit = () => {
    if (titleReview === '' || yearSchool === '' || period.length === 0) {
      toast?.pushWarning(RESPONSE_MESSAGE.WARN.ADD_REVIEW_EDU_SUCCESS);
      return;
    }
    if (valueDonVi === '') {
      toast?.pushWarning('Vui lòng chọn đơn vị!');
      return;
    }
    const data = {
      evaluation_id: id,
      title: titleReview,
      evaluation_code_id: valueDonVi,
      standards: [],
      classifications: [],
      delete_standard_ids: [],
      delete_criteria_ids: [],
      delete_classification_ids: [],
      period_ids: [1],
      course_id: parseInt(yearSchool),
      department_id: valueDepartment
    };
    // const request = {
    //   evaluationId: id,
    //   classifications: [],
    //   standards: [],
    //   deleteClassificationIds: [],
    //   title: titleReview,
    //   deleteStandardIds: [],
    //   deleteCriteriaIds: [],
    //   courseId: parseInt(yearSchool),
    //   periodId: period
    // };
    competitionRatingHttp.updateReviewRolePgd1(data).then((res) => {
      if (res.ok && res.status === 200) {
        toast?.pushSuccess(RESPONSE_MESSAGE.SUCCESS.EDIT_REVIEW_EDU_SUCCESS);
        handleCancel();
        handleRefresh();
      } else {
        toast?.pushError(RESPONSE_MESSAGE.FAIL.EDIT_REVIEW_EDU_FAIL);
      }
    });
  };

  const tagRender = (props: CustomTagProps) => {
    const { label, closable, onClose } = props;
    const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
      event.preventDefault();
      event.stopPropagation();
    };
    return (
      <Tag
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        style={{ marginRight: 3, fontSize: '14px', fontWeight: '400', lineHeight: '25px' }}>
        {label}
      </Tag>
    );
  };

  return (
    <Modal
      title={title}
      centered
      visible={isOpen}
      onCancel={() => handleCancel()}
      width={800}
      maskClosable={false}
      footer={[
        <Button key="back" size="large" onClick={handleCancel}>
          Đóng
        </Button>,
        <Button key="submit" size="large" type="primary" onClick={handleSubmit}>
          Cập nhật
        </Button>
      ]}>
      <Container>
        <Card>
          <div className="mb-15">
            <label htmlFor="" className="font-bold mb-10 block">
              Tên đánh giá
            </label>
            <input
              type="text"
              className="w-full h-44 font-montserrat border-1 text-15 placeholder:text-999 border-solid border-cbce shadow-lg rounded-5 px-15"
              placeholder="Nhập thông tin"
              onChange={onChangeValue}
              value={titleReview}
            />
          </div>
          <div className="grid sm:grid-2 gap-15 sm:gap-20">
            <div>
              <label htmlFor="" className="font-bold mb-10 block">
                Năm học
              </label>
              <div className="relative">
                <StyleSelectCourse
                  style={{ width: 350, height: 40 }}
                  placeholder="Chọn năm học"
                  value={yearSchool}
                  onChange={onSelectYear}>
                  {!_.isEmpty(listCourse) &&
                    listCourse.map((item) => (
                      <Option value={item.id} key={item.id}>
                        {item.description}
                      </Option>
                    ))}
                </StyleSelectCourse>
              </div>
            </div>
            <div>
              <label htmlFor="" className="font-bold mb-10 block">
                Chọn đơn vị
              </label>
              <div className="relative">
                <StyleSelectCourse
                  style={{ width: 350, height: 40 }}
                  placeholder="Chọn cơ đơn vị"
                  value={valueDonVi}
                  onChange={onChangeOptionDonvi}>
                  {!_.isEmpty(groupUnitPgd) &&
                    groupUnitPgd.map((item) => (
                      <Option value={item.id} key={item.id}>
                        {item.title}
                      </Option>
                    ))}
                </StyleSelectCourse>

                {/* <StyleSelectPeriod
                  mode="multiple"
                  style={{
                    width: 350,
                    height: 40,
                    position: 'relative'
                  }}
                  value={period}
                  tagRender={tagRender}
                  placeholder="Chọn quý"
                  onChange={onSelectPeriod}
                  // value={period}
                  dropdownStyle={{ width: '350' }}>
                  {!_.isEmpty(listPeriod.periods) &&
                    listPeriod.periods.map((item) => (
                      <Option value={item.id} key={item.id} title={item.title}>
                        {item.title}
                      </Option>
                    ))}
                </StyleSelectPeriod>
                <IconDropdown>
                  <DownOutlined />
                </IconDropdown> */}
              </div>
            </div>
          </div>
        </Card>
      </Container>
    </Modal>
  );
}

export default ModalEditReviewRoleEdu;
